(function () {
  'use strict';

  var COLOR_VALUES = ['steel', 'black', 'white'];

  function getValue(node) {
    return ((node && node.dataset && node.dataset.value) || '').trim();
  }

  function ensureColorSoldOutMarkup(node, label) {
    var value = getValue(node);
    var isColor = COLOR_VALUES.indexOf(value.toLowerCase()) !== -1;
    node.classList.toggle('vm-soldout-color', isColor && node.classList.contains('m-product-option--node__soldout'));

    var oldName = label.querySelector('.vm-variant-name');
    var oldSold = label.querySelector('.vm-soldout-text');

    if (!(isColor && node.classList.contains('m-product-option--node__soldout'))) {
      if (oldName) {
        oldName.replaceWith(document.createTextNode(oldName.textContent));
      }
      if (oldSold) oldSold.remove();
      return;
    }

    if (!oldName) {
      var textNode = Array.prototype.find.call(label.childNodes, function (child) {
        return child.nodeType === Node.TEXT_NODE && child.textContent.trim();
      });
      var name = document.createElement('span');
      name.className = 'vm-variant-name';
      name.textContent = textNode ? textNode.textContent.trim() : value;
      if (textNode) textNode.replaceWith(name);
      else label.appendChild(name);
    }

    if (!label.querySelector('.vm-soldout-text')) {
      var sold = document.createElement('span');
      sold.className = 'vm-soldout-text';
      sold.textContent = 'SOLD OUT';
      label.appendChild(sold);
    }
  }

  function syncSoldOut(root) {
    (root || document).querySelectorAll('variant-picker .m-product-option--node').forEach(function (node) {
      var label = node.querySelector('.m-product-option--node__label');
      var input = node.querySelector('input[type="radio"]');
      if (!label) return;
      var soldOut = node.classList.contains('m-product-option--node__soldout');

      ensureColorSoldOutMarkup(node, label);

      if (soldOut) {
        label.setAttribute('aria-disabled', 'true');
        label.setAttribute('title', (getValue(node) + ' — Sold out').trim());
        if (input) input.setAttribute('aria-disabled', 'true');
      } else {
        label.removeAttribute('aria-disabled');
        label.removeAttribute('title');
        if (input) input.removeAttribute('aria-disabled');
      }
    });
  }

  function init() {
    syncSoldOut(document);
    document.querySelectorAll('variant-picker').forEach(function (picker) {
      var observer = new MutationObserver(function (mutations) {
        var needsSync = mutations.some(function (m) {
          return m.type === 'attributes' && m.attributeName === 'class';
        });
        if (needsSync) syncSoldOut(picker);
      });
      observer.observe(picker, { subtree: true, attributes: true, attributeFilter: ['class'] });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
